import React, { useCallback } from 'react'
import GeralForm from './GeralForm'
import PaymentForm from './PaymentForm'
import HelpForm from './HelpForm'
import { Container } from './styles'
import faqs from './faq.json'

interface ProfileFormProps {
  type: string
  order?: string
}

const ProfileForm: React.FC<ProfileFormProps> = ({ type, order }) => {
  const switchForm = useCallback(() => {
    if (type === 'payment') return <PaymentForm order={order} />
    if (type === 'help') return <HelpForm faqs={faqs} />

    return <GeralForm />
  }, [type])

  return <Container>{switchForm()}</Container>
}

export default ProfileForm
